import { PropsWithChildren, memo } from 'react';
import clsx from 'clsx';
import { ComponentMemo } from '@headless-workspace/typings';
import { ArrayHelpers } from '@headless-workspace/utils';

type GlowSkeletonProps = PropsWithChildren & {
    containerClassName?: string;
    isLoaded?: boolean;
    height?: number | string;
    width?: number | string;
    line?: number;
    itemClassName?: string;
};

export const GlowSkeleton: ComponentMemo<GlowSkeletonProps> = memo(
    ({ children, isLoaded = false, height = '100%', width = '100%', line = 1, containerClassName, itemClassName }) => {
        if (isLoaded) {
            return children;
        }

        return (
            <div className={clsx('flex flex-col gap-0.5', 'animate-pulse', containerClassName, 'skeleton')}>
                {ArrayHelpers.createSequentialArray(line).map((_, index) => (
                    <div
                        key={index}
                        data-testid={`skeleton-${index}`}
                        style={{
                            height,
                            width,
                        }}
                        className={clsx('bg-background-skeleton rounded-0.5', itemClassName)}
                    />
                ))}
            </div>
        );
    },
);
